import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import AnimatedPage from '@/components/AnimatedPage'

export default function ResearchShell({ children }: { children: ReactNode }) {
  return (
    <AnimatedPage>
      <div className="flex min-h-screen flex-col">
        <header className="border-b border-[#DDE3DF] bg-white">
          <div className="aelo-container flex min-h-[4.75rem] flex-wrap items-center justify-between gap-4 py-3">
            <Link
              to="/"
              aria-label="Aelo home"
              className="inline-flex min-h-11 items-center rounded-md px-2 transition-opacity hover:opacity-70 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#2E9FB9]"
            >
              <img
                src="/assets/aelo-logo.png?v=20260509b"
                alt="Aelo"
                className="h-6 w-auto"
              />
            </Link>
            <nav aria-label="Research navigation" className="flex flex-wrap items-center gap-1 text-sm">
              <Link
                to="/research"
                className="inline-flex min-h-11 items-center rounded-full px-4 font-semibold text-[#29444C] transition hover:bg-[#F2F7F6] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#2E9FB9]"
              >
                Research library
              </Link>
              <Link
                to="/about"
                className="inline-flex min-h-11 items-center rounded-full px-4 font-semibold text-[#536168] transition hover:bg-[#F2F7F6] hover:text-[#29444C] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#2E9FB9]"
              >
                About Aelo
              </Link>
              <Link
                to="/founding"
                className="inline-flex min-h-11 items-center rounded-full bg-[#142126] px-5 font-semibold text-white transition hover:bg-[#29444C] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#2E9FB9]"
              >
                Join early access
              </Link>
            </nav>
          </div>
        </header>

        <main className="flex-1">{children}</main>

        <footer className="border-t border-[#DDE3DF] bg-[#FCFCFA]">
          <div className="aelo-container flex flex-col items-center justify-between gap-4 py-8 text-sm text-[#617078] sm:flex-row">
            <p>&copy; {new Date().getFullYear()} Aelo. Pre-launch research library.</p>
            <nav aria-label="Research footer" className="flex flex-wrap items-center gap-5">
              <Link className="transition hover:text-[#142126]" to="/research">
                Research
              </Link>
              <Link className="transition hover:text-[#142126]" to="/privacy">
                Privacy
              </Link>
              <Link className="transition hover:text-[#142126]" to="/terms">
                Terms
              </Link>
            </nav>
          </div>
        </footer>
      </div>
    </AnimatedPage>
  )
}
